import React from "react";
import { useTranslation } from "react-i18next";

/**
 * 页面头部组件
 */
const Footer = () => {
  const { t } = useTranslation(["footer", "personalCenterSiderBar", "common"]);

  return (
    <footer className="footer">
      <div className="container-xl">
        <div className="text-center small text-muted">
          <p className="py-3 m-0">{t("copyright")}</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
